import { Address, Company } from '@kanda-libs/ks-frontend-services';

import { formatDate } from 'utils';

export interface BaseCompanyInfo {
  companyName: string;
  contactEmail: string;
  contactName: string;
  contactPhone: string;
  contactAddress: string;
}

export interface FormattedCompany extends BaseCompanyInfo {
  cid: string;
  createdAt: string;
}

const formatAddress = (address?: Address): string => {
  if (!address) return '--';
  const toCheck = address?.building_number || address?.building_name;
  const checkLine1 = toCheck ? address.line_1.includes(toCheck) : true;
  return [
    checkLine1 ? undefined : address?.building_number || address?.building_name,
    address?.line_1,
    address?.line_2,
    address?.city,
    address?.postcode,
  ]
    .filter(Boolean)
    .join(', ');
};

export const formatBaseCompanyInfo = (company: Company): BaseCompanyInfo => {
  if (company.company_type === 'limited_company')
    return {
      companyName:
        company?.contact_info?.trading_name ||
        company?.limited_company_info?.company_name ||
        '--',
      contactEmail: company?.contact_info?.contact_email || '--',
      contactName: company?.contact_info?.contact_name || '--',
      contactPhone: company?.contact_info?.contact_phone || '--',
      contactAddress: formatAddress(
        company?.contact_info?.contact_address ||
          company?.limited_company_info?.company_address,
      ),
    };
  return {
    companyName:
      company?.contact_info?.trading_name ||
      company?.sole_trader_info?.trading_name ||
      '--',
    contactEmail: company?.contact_info?.contact_email || '--',
    contactName: company?.contact_info?.contact_name || '--',
    contactPhone: company?.contact_info?.contact_phone || '--',
    contactAddress: formatAddress(
      company?.contact_info?.contact_address ||
        company?.limited_company_info?.company_address,
    ),
  };
};

export const formatCompanyData = (
  companies: Company[] | undefined,
): FormattedCompany[] => {
  if (!companies) return [];
  return companies.map((company: Company) => ({
    cid: company?.cid || '--',
    ...formatBaseCompanyInfo(company),
    createdAt: formatDate(
      company?.metadata?.created_at
        ? new Date(company.metadata.created_at)
        : undefined,
      'YYYY-MM-DD',
    ),
    updatedAt: formatDate(
      company?.metadata?.updated_at
        ? new Date(company.metadata.updated_at)
        : undefined,
      'YYYY-MM-DD',
    ),
  }));
};
